import "@withmethod/design/privacy.css";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { RouterProvider } from "@tanstack/react-router";
import { QueryClientProvider } from "@tanstack/react-query";
import { createAppRouter } from "./router";
import { createQueryClient } from "./query-client";
import "@withmethod/design/theme.css";
import "./theme.css";
import "./login.css";
import { startBootRequests } from "./boot-requests";

startBootRequests(window.location.pathname);
const router = createAppRouter();
const queryClient = createQueryClient();
createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />
    </QueryClientProvider>
  </StrictMode>,
);
